import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useIsTF911Enabled from '@rsos/hooks/useIsTF911Enabled';
import {
  setCardsToRender,
  closeCard,
  OUTBOUND_SMS_CARD,
} from '@rsos/reduxDataStore/src/features/mapCard/mapCardSlice';
import type { RootState } from '../../../../app/rootReducer';
import { trackTogglingOutboundSMSCard } from '../../CallChats/textFrom911Trackings';

const useOutboundSMSHelpers = () => {
  const dispatch = useDispatch();
  const isTF911Enabled = useIsTF911Enabled();
  const isOutboundSMSCardOpened = useSelector(
    (state: RootState) => state.mapCard.cards[OUTBOUND_SMS_CARD],
  );

  const handleOutboundSMSClick = useCallback(() => {
    if (isOutboundSMSCardOpened) {
      dispatch(closeCard(OUTBOUND_SMS_CARD));
    } else {
      dispatch(setCardsToRender(OUTBOUND_SMS_CARD));
    }
    trackTogglingOutboundSMSCard({
      show: !isOutboundSMSCardOpened,
      isMapCardCloseBtn: false,
    });
  }, [isOutboundSMSCardOpened, dispatch]);

  return {
    handleOutboundSMSClick,
    isTF911Enabled,
    isOutboundSMSCardOpened,
  };
};

export default useOutboundSMSHelpers;
